// ─── Qué acciones ve cada cargo en Secciones (S0·SEC-1b) ─────────────────────
// Crear, editar, configurar y borrar períodos, e importar alumnos, son de
// administración, registro y decanato (`useCanManageAcademics` =
// SECTION_MANAGEMENT_ROLES del servidor). El servidor ya los rechazaba al
// docente y al mentor; además, «Nuevo período» y «Materias» cargan el plantel
// docente completo desde el cliente, que esos cargos dejan de poder leer. Un
// docente o un mentor llega a esta pantalla para VER sus períodos y entrar al
// detalle, sin botones que fallarían. Mismo criterio que term-detail.actions.

export type TermCardAction = 'edit' | 'configure' | 'delete' | 'open';

export function termCardActions(opts: {
  canManage: boolean;
  /** Período cerrado o planificado: los abiertos o en curso no se borran. */
  isDeletable: boolean;
}): TermCardAction[] {
  if (!opts.canManage) return ['open'];
  return opts.isDeletable ? ['edit', 'configure', 'delete', 'open'] : ['edit', 'configure', 'open'];
}

export type SectionsHeaderAction = 'importStudents' | 'newTerm';

export function sectionsHeaderActions(opts: { canManage: boolean }): SectionsHeaderAction[] {
  return opts.canManage ? ['importStudents', 'newTerm'] : [];
}
